import { Component, computed, inject } from '@angular/core';
import { AppConfigLoader } from '@hunting-nature/Secacam/config/app-config.loader';
import { AppButtonComponent } from '@hunting-nature/shared-ui/components/app-button/app-button.component';
import { IonIcon } from '@ionic/angular/standalone';
import { TranslocoPipe } from '@jsverse/transloco';
import { Store } from '@ngrx/store';

import { GeneralActions } from '../../../shared/redux/general/general.actions';

@Component({
  selector: 'app-shop-card',
  imports: [TranslocoPipe, IonIcon, AppButtonComponent],
  templateUrl: './shop-card.html',
  styleUrl: './shop-card.scss',
  standalone: true,
})
export class ShopCard {
  // services
  private readonly store = inject(Store);
  private readonly appConfigLoader = inject(AppConfigLoader);

  // UI bindings
  /**
   * Exchangeable background image with linear-gradient
   */
  readonly backgroundImageUrl$$ = computed(() => `url(${this.appConfigLoader.activeConfig().shopCardImageUrl})`);

  handleOpenShop(): void {
    this.store.dispatch(GeneralActions.openShop());
  }
}
